import { render } from "./FooterText.vue?vue&type=template&id=cd16e996&scoped=true"
import script from "./FooterText.vue?vue&type=script&lang=js"
export * from "./FooterText.vue?vue&type=script&lang=js"

import "./FooterText.vue?vue&type=style&index=0&id=cd16e996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd16e996"]])

export default __exports__